import React, { useEffect } from "react";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";
import CommonLoading from "../CommonLoading";

const truncateText = (text, maxLength) => {
  if (text && text.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};
const truncateColumns = ["email", "description", "first_name", "room_type"];

const DataTable = ({
  columns,
  data,
  pageSize,
  setPageSize,
  onSortChange,
  isLoading,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize: updatePageSize,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    updatePageSize(pageSize);
  }, [pageSize]);

  useEffect(() => {
    if (onSortChange && sortBy.length > 0) {
      onSortChange(sortBy[0]);
    }
  }, [sortBy]);

  const renderTableHeaders = () => (
    <thead>
      {headerGroups.map((headerGroup, index) => (
        <tr
          key={index}
          {...headerGroup.getHeaderGroupProps()}
          className="small text-muted text-uppercase text-start"
        >
          {headerGroup.headers.map((column, index) => (
            <th
              key={index}
              {...column.getHeaderProps(column.getSortByToggleProps())}
              style={{ width: column.width }}
            >
              {column.render("Header")}
              {column.id !== "actions" && (
                <span style={{ opacity: 0.5, cursor: "default" }}>
                  <span style={{ marginRight: 2 }}>&#x2191;</span>
                  <span>&#x2193;</span>
                </span>
              )}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );

  const renderTableRows = () => (
    <tbody className="bg-primary" {...getTableBodyProps()}>
      {isLoading ? (
        [...Array(pageSize)].map((_, rowIdx) => (
          <tr key={`loading-${rowIdx}`}>
            {columns.map((col, colIdx) => (
              <td key={`loading-${rowIdx}-${colIdx}`}>
                <div className="placeholder-glow">
                  <span
                    className="placeholder col-12"
                    style={{ height: "1rem", display: "block", width: "100%", }}
                  ></span>
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : page.length === 0 ? (
        <tr>
          <td colSpan={columns.length}>
            <div className="w-100 d-flex justify-content-center align-items-center fw-semibold mt-2">
              No data available
            </div>
          </td>
        </tr>
      ) : (
        page.map((row, index) => {
          prepareRow(row);
          return (
            <tr key={index} {...row.getRowProps()} className="row-selectable">
              {row.cells.map((cell) => (
                <td
                  key={cell.column.id}
                  {...cell.getCellProps()}
                  className={`text-start align-middle`}
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    width: cell.column.width,
                  }}
                >
                  {cell.column.id === "email" || cell.column.id === "description" ||
                    cell.column.id === "first_name" ? (
                    <span
                      title={cell.value}
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {truncateText(cell.value, 20)}
                    </span>
                  ) : (
                    cell.render("Cell")
                  )}
                </td>
              ))}
            </tr>
          );
        })
      )}
    </tbody>
  );

  return (
    <div className="table-responsive position-relative" style={{ maxHeight: "75vh", overflowX: "auto" }}>
      <table
        {...getTableProps()}
        className="table align-middle table-hover dataTable"
        // style={{ tableLayout: "fixed" }}
        style={{ minWidth: "1000px", whiteSpace: "nowrap", tableLayout: "fixed" }}
      >
        {renderTableHeaders()}
      </table>

      <div
        style={{ maxHeight: "50vh", overflowY: "auto", position: "relative" }}
      >
        <table
          className="table align-middle table-hover dataTable"
          style={{ tableLayout: "fixed" }}
        >
          {renderTableRows()}
        </table>

        {isLoading && (
          <div
            className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
              top: 0,
              left: 0,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              zIndex: 10,
            }}
          >
            <CommonLoading />
          </div>
        )}
      </div>
    </div>
  );
};

export default DataTable;
